import { PARTNER_STATUS } from './partnerStatus'
import { ORDER_STATUS_LABEL } from './materialOrder.logic'

// 공종 삭제 확인창의 '이미 진행된 일정' 경고 — 파트너에게 알림이 나간 뒤(일정확인 발송·확정, 발주정보 발송 이후)라면
// 삭제가 무엇을 되돌리는지 줄마다 알려 준다. 삭제를 막지는 않는다.
// 서버 삭제 동작(TaskService#delete): 확정 반장 → 배정 취소 안내 카톡 / 회신 대기 요청 → 안내 없이 링크 마감 /
// 발주 → 열린 발송 마감·거래처 링크 회수(거래처 안내 없음).

export interface DeleteTargetTask {
  taskId: number
  workTypeName: string
  partnerStatus?: string | null
  foremanName?: string | null
}

export interface DeleteTargetOrderRow {
  taskId: number
  vendorName?: string | null
  orderStatusCode: string
}

/** 발송 전·교체로 닫힌 발주는 거래처에 나간 게 없어 경고하지 않는다 */
const QUIET_ORDER_STATUSES = new Set(['DRAFT', 'REPLACED'])

/** 이미 진행된 일 한 줄씩(없으면 빈 배열). 여러 공종이면 줄 앞에 공종명을 붙인다 */
export function taskProgressWarnings(tasks: DeleteTargetTask[], rows: DeleteTargetOrderRow[]): string[] {
  const multi = tasks.length > 1
  const lines: string[] = []
  for (const t of tasks) {
    const head = multi ? `${t.workTypeName} — ` : ''
    const who = t.foremanName ? `${t.foremanName} 반장님` : '반장님'
    if (t.partnerStatus === PARTNER_STATUS.CONFIRMED) {
      lines.push(`${head}${who} 일정이 확정됐어요 · 삭제하면 반장님께 배정 취소 안내 카톡이 나가요`)
    } else if (t.partnerStatus === PARTNER_STATUS.WAITING) {
      lines.push(`${head}${who}께 일정확인을 보냈어요(회신 대기) · 삭제하면 요청이 마감돼요`)
    } else if (t.partnerStatus === PARTNER_STATUS.DECLINED || t.partnerStatus === PARTNER_STATUS.UNFIXED) {
      lines.push(`${head}${who}께 일정확인을 보낸 기록이 있어요`)
    }
    for (const r of rows) {
      if (r.taskId !== t.taskId || QUIET_ORDER_STATUSES.has(r.orderStatusCode)) continue
      const status = (ORDER_STATUS_LABEL as Record<string, string | undefined>)[r.orderStatusCode] ?? '발주 진행 중'
      lines.push(`${head}자재파트너 ${r.vendorName || '거래처'}: ${status} · 삭제하면 거래처 링크가 마감돼요(거래처에 따로 알림은 가지 않아요)`)
    }
  }
  return lines
}

/** 기본 삭제 확인 문구 뒤에 경고 줄을 붙인다. 경고가 없으면 기본 문구 그대로 */
export function withProgressWarning(base: string, lines: string[]): string {
  if (lines.length === 0) return base
  return `${base}\n\n⚠ 이미 진행된 일정이 있어요\n${lines.map(l => `· ${l}`).join('\n')}\n\n그래도 삭제할까요?`
}
